import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ContentTemplate from "../../components/landing/templates/ContentTemplate";
import { activeMenuItem } from "../../actions/headerActions";

const ContentContainer = (props) => <ContentTemplate {...props} />;

const mapStateToProps = (state) => {
  return {
    menuTitle: state.headers.menuTitle,
  };
};

export default withRouter(connect(mapStateToProps, { activeMenuItem })(ContentContainer));